import { render } from "./home.vue?vue&type=template&id=726c91f6"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
script.render = render

export default script